<template>
	<div class="fishbone-container">
	    <div class="fishbone-main"></div>
	    <ul class="steps">
			<li>
			    <div class="step-triangle"></div>
			</li>
	        <li class="step">
	            <span class="step-text">前期采购资料</span>
	            <div class="step-dot"></div>
				<div style="position: absolute; left: -145px; top: -270px; width: 150px; height: 260px;">
					<el-timeline style="width: 100%;">
					    <el-timeline-item timestamp="2018-04-15" size="large" placement="top" style="margin-left: -30px;">
					      活动按期开始111
					    </el-timeline-item>
						<el-timeline-item timestamp="2018-04-15" size="large" placement="top" style="margin-left: -30px;">
						  活动按期开始111
						</el-timeline-item>
					  </el-timeline>
				</div>
	        </li>
	        <li class="step">
	            <span class="step-text">会议纪要</span>
	            <div class="step-dot"></div>
				<div style="position: absolute; left: -145px; top: 60px; width: 150px; height: 260px;">
					<el-timeline style="width: 100%;">
					    <el-timeline-item timestamp="2018-04-15" size="large" placement="top" style="margin-left: -30px;">
					      活动按期开始111
					    </el-timeline-item>
						<el-timeline-item timestamp="2018-04-15" size="large" placement="top" style="margin-left: -30px;">
						  活动按期开始111
						</el-timeline-item>
					  </el-timeline>
				</div>
	        </li>
	        <li class="step">
	            <span class="step-text">阳光采购审批单</span>
	            <div class="step-dot"></div>
	        </li>
	        <li class="step">
	            <span class="step-text">招标公告</span>
	            <div class="step-dot"></div>
	        </li>
	        <li class="step">
	            <span class="step-text">中标公告</span>
	            <div class="step-dot"></div>
	        </li>
			<li class="step">
			    <span class="step-text">采购过程纪要</span>
			    <div class="step-dot"></div>
			</li>
			<li class="step">
			    <span class="step-text">合同审批单</span>
			    <div class="step-dot"></div>
			</li>
			<li class="step">
			    <span class="step-text">合同</span>
			    <div class="step-dot"></div>
			</li>
			<li class="step">
			    <span class="step-text">结束</span>
			    <div class="step-dot"></div>
			</li>
			<li>
			    <div class="step-triangle2"></div>
			</li>
	    </ul>
	</div>

</template>

<script>
	import utils from "@/assets/js/utils";
	import global from "@/assets/js/globalconfig";
	export default {
		name: "test",
		components: {
		},
		data() {
			return {
				
			};
		},
		created() {
		},
		mounted() {
		},
		beforeDestroy() {
		},
		computed: {
		},
		methods: {

		},
	};
</script>
<style lang="scss" scoped>
	   .fishbone-container {
	              width: 85%;
	              margin: 80px auto;
	              position: relative;
				  margin-top: 300px;
	          }
	  
	          /* 主干横线 */
	          .fishbone-main {
	              height: 3px;
	              background: #2979ff;
	              position: absolute;
	              top: 12px;
	              left: 0;
	              right: 0;
	              z-index: 1;
	          }
	  
	          .steps {
	              display: flex;
	              justify-content: space-between;
	              list-style: none;
	              padding: 0;
	              margin: 0;
	              position: relative;
	              z-index: 2;
	          }
	  
	          .step {
	              display: flex;
	              flex-direction: column;
	              align-items: center;
	              position: relative;
	          }
	  
	          /* 步骤圆点 */
	          .step-dot {
	              width: 22px;
	              height: 22px;
	              border-radius: 50%;
	              background: #fff;
	              border: 3px solid #2979ff;
	              position: relative;
	              z-index: 3;
	          }
	  
	          .step-done .step-dot {
	              background: #2979ff;
	          }
			  
			  .step-triangle {
				border-top: 20px solid transparent;
				border-bottom: 20px solid transparent;
				border-left: 30px solid #2979ff;
				margin-top: -7px;
				margin-left: -20px;
				position: absolute;
			  }
			  
			  .step-triangle2 {
				border-top: 40px solid transparent;
				border-bottom: 40px solid transparent;
				border-left: 50px solid #2979ff;
				margin-top: -26px;
				margin-left: 0px;
				position: absolute;
			  }
			  	  
	  
	          /* —————— 竖线分支（一上一下）—————— */
	          .step::before {
	              content: '';
	              position: absolute;
	              width: 2px;
	              background: #2979ff;
	              z-index: 1;
	          }
	          .step:nth-child(odd)::before {
	              height: 300px;
	              top: 0px;
	          }
	          .step:nth-child(even)::before {
	              height: 300px;
	              bottom: 0px;
	          }
			  
			  
			   /* —————— 竖线尾部箭头（核心新增）—————— */
			  .step::after {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				border-left: 6px solid transparent;
				border-right: 6px solid transparent;
			  }
			  .step:nth-child(odd)::after {
				border-top: 10px solid #2979ff;
				bottom: -280px;
			  }
			  .step:nth-child(even)::after {
				border-bottom: 10px solid #2979ff;
				top: -280px;
			  }
			  
			  
	          /* —————— 文字贴在圆点上下（不超出竖线）—————— */
	          .step-text {
	              position: absolute;
	              font-size: 14px;
	              color: #333;
	              white-space: nowrap;
	              z-index: 4;
	          }
	  
	          /* 奇数：文字在圆点上方 */
	          .step:nth-child(odd) .step-text {
	              bottom: 30px; /* 紧贴圆点上方，不飘出去 */
	          }
	  
	          /* 偶数：文字在圆点下方 */
	          .step:nth-child(even) .step-text {
	              top: 30px; /* 紧贴圆点下方 */
	          }
</style>
